import basketsController from './basketsController'

export default basketsController



// WEBPACK FOOTER //
// ../src/controllers/basketsController/index.js